import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-index-view',
  templateUrl: './index-view.component.html',
  styleUrls: ['./index-view.component.scss',]
})
export class IndexViewComponent implements OnInit {
  constructor(private route:ActivatedRoute,@Inject(DOCUMENT) private document:Document) { }

  title: string = 'bhavani_Landing';
  platformBaseUrl = $localize.locale ==='es'? `https://my.bhavani.app/es/`: `https://my.bhavani.app/en/`
  protected iparam:string|null=null;
  protected referalCode:string=this.getCookie('referenceBhavani');
  public learnMoreBtn: string = $localize`Aprender más`;
  public benefits_header: string = $localize`¿Cuáles son los beneficios?`;
  public protocols_header: string = $localize`Protocolos`;
  public beneftis_paragraph: any = $localize`Todos nuestros tratamientos son especialmente seleccionados para tratar diferentes áreas problema.<br><br> Estas son algunas de las áreas que se pueden tratar:`;
  public protocols_paragraph: any = $localize`Más de 6,000 personas como tu han elegido los protocolos de Bhavani, que se han perfeccionado gracias a una amplia colaboración. Permítenos crear un protocolo de microdosis personalizado para ti hoy.`;
  public formulaHeader: any = $localize`Nuestras <span style="font-style: italic;">Fórmulas</span>.`;
  public formulaParagraph: any = $localize`
    Nuestras fórmulas se desarrollan a partir de nuestro banco genético, que cuenta con una variedad de 180 especies diferentes de hongos. <br><br>
    El hongo es una inteligencia que se adapta a tu sistema y sanará lo que tu sistema nervioso y tu cuerpo psico-emocional necesiten sanar. Cada persona establece una relación personal con el hongo y tiene una respuesta y sensibilidad distinta.<br><br>
    Es muy probable que durante un tratamiento de 90 días desees probar diferentes fórmulas que se complementen entre sí y ofrezcan diferentes matices a tu proceso.<br><br>
    Las descripciones de las fórmulas no deben limitar la experiencia generando expectativas específicas, sino que intentan mostrar cómo los distintos tipos de hongos tienen diferentes tendencias, diferentes formas de sanar, y cómo enfatizan algunos aspectos de nuestra experiencia en el proceso.
  `;
  private getCookie(name: string) {
    let ca: Array<string> = this.document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if(params['i']) params['i'] === '1' ? this.iparam=params['i'] : this.iparam='0';
    });
  }

}
